export default "__VITE_ASSET__12e8d69a__"